import React from "react";
import { formatNumber } from "../Utils/utils";
import List from "./list";

const CardFormIg = ({ items, openModalPdf, simbolo }) => {
  const data = items.responseCotizacion || "";
  const currency = simbolo ? (simbolo === "USD" ? "$" : "S/") : "";
  const saldoNeto = data
    ? formatNumber.new(parseFloat(data.detalle_plan.saldo_neto).toFixed(2))
    : "0";
  const primaComercial = data
    ? formatNumber.new(parseFloat(data.detalle_plan.prima_comercial).toFixed(2))
    : "";
  const cargoAdm = data ? data.detalle_plan.cargo_administracion : "";
  const impuestoGan = data ? data.detalle_plan.impuesto_ganancia : "";
  const plazo = data ? data.detalle_plan.plazo + " años" : "";
  const fechVencimiento = data
    ? data.detalle_plan.fecha_vencimiento.replace(/\-/g, "/")
    : "";

  return (
    <section className="modaldata">
      <div className="modaldata__content">
        <div className="modaldata__balance">
          <div className="balance__title">Saldo Esperado Neto</div>
          <span className="balance__currency">{currency || "$"}</span>
          <span className="balance__amount">{saldoNeto}</span>
        </div>
        <List>
          <li>
            <b>Prima Comercial:&nbsp;</b> {currency} {primaComercial}
          </li>
          <li>
            <b>Prima Invertida:&nbsp;</b> {currency} {primaComercial}
          </li>
          <li>
            <b>Cargo anual de administración de fondo:&nbsp;</b>
            {cargoAdm}
          </li>
          <li>
            <b>Impuesto a la ganancia:&nbsp;</b>
            {impuestoGan}
          </li>
          <li>
            <b> Plazo:&nbsp;</b> {plazo}
          </li>
          <li>
            <b>Fecha de Vto - Cotización:&nbsp;</b>
            {fechVencimiento}
          </li>
        </List>
        <div className="link-sep">
          <span className="modaldata__link" onClick={() => openModalPdf()}>
            Ver cotizaciones
          </span>
        </div>
      </div>
    </section>
  );
};
export default CardFormIg;
